import { Button, Card, Col, Form, Input, message, Popconfirm, Row, Table, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addRate, deleteRate, getAllRate, updateRate } from '../../redux/rtk/features/masters/rateSlice';
import PageTitle from '../page-header/PageHeader';

const RateMaster = () => {
  const { Title } = Typography;

  const [editingRate, setEditingRate] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { list, loading } = useSelector((state) => state.rate);

  useEffect(() => {
    dispatch(getAllRate());
  }, [dispatch]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      if (editingRate) {
        // Update existing rate
        const result = await dispatch(
          updateRate({ id: editingRate.id, values })
        ).unwrap();
        if (result.message === 'success') {
          dispatch(getAllRate());
        } else {
          message.error('Error updating rate!');
        }
      } else {
        // Add new rate
        const result = await dispatch(addRate(values)).unwrap();
        if (result.message === 'success') {
          dispatch(getAllRate());
        } else {
          message.error('Error adding rate!');
        }
      }
      setEditingRate(null);
    } catch (error) {
      console.error('Validation failed or API error:', error);
      message.error('Failed to add or update rate!');
    }
  };

  // Handle deletion
  const handleDelete = async (id) => {
    try {
      const result = await dispatch(deleteRate(id)).unwrap();
      if (result?.message === 'success') {
        dispatch(getAllRate()); // Refresh table data
      } else {
      }
    } catch (error) {
      console.error('Delete API error:', error);
    }
  };

  // Table columns
  const columns = [
    {
      title: 'Rate',
      dataIndex: 'rate',
      key: 'rate',
    },

    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Button type="link" onClick={() => {
            setEditingRate(record);
            form.setFieldsValue(record);
          }
          }>
            Edit
          </Button>
          <Popconfirm
            title="Are you sure you want to delete this rate?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>
              Delete
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <PageTitle title='Back' />
      <Row gutter={16}>
        <Col span={8}>
          <Card title={editingRate ? 'Edit Rate' : 'Add Rate'}>
            <Form
              form={form}
              style={{ marginBottom: "40px" }}
              name="rate-form"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 14 }}
              onFinish={handleOk}
              autoComplete="off"
            >
              <Form.Item
                name="rate"
                label="Rate"
                rules={[{ required: true, message: 'Please enter a rate!' }]}
              >
                <Input placeholder="Enter rate" />
              </Form.Item>
              <Button type="primary" block htmlType="submit">
                {editingRate ? 'Update Rate' : 'Add Rate'}
              </Button>
            </Form>
          </Card>
        </Col>
        <Col span={16}>
          <Card title="Rate List">
            <Table
              dataSource={list}
              columns={columns}
              rowKey="id"
              loading={loading}
              style={{ marginTop: 0 }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RateMaster;
